module.exports = ".header-img {\n    float: right;\n}\n\n.dx-fileuploader-file-container {\n    width: 250px;\n    float: left;\n    margin: 5px;\n}\n\nbody {\n    overflow: hidden;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles